import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkingCopyBackupService = ( createDecorator('workingCopyBackupService'));
export { IWorkingCopyBackupService };
